import * as React from 'react';

import styles from './OfferMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessageRow } from '../../../ChatMessageRow';
import { MetaRow } from '../MetaRow';

interface IOfferMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  offerMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  actionButtons: React.ReactNode;
  userColor?: EUserColor;
}

export const OfferMessageLayout = React.forwardRef<HTMLDivElement, IOfferMessageLayoutProps>(
  function OfferMessageLayout(
    { errorSign, errorText, messageType, isLastMessageInChain, offerMessage, messageMeta, actionButtons, userColor },
    ref,
  ) {
    return (
      <ChatMessageRow errorSign={errorSign} errorText={errorText}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['offer-message__bubble']}
          ref={ref}
          userColor={userColor}
        >
          {offerMessage}
          {actionButtons}
          <MetaRow messageType={messageType} className={styles['offer-message__meta']} userColor={userColor}>
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessageRow>
    );
  },
);
